import * as React from 'react';
import { Menu, } from '@dropbox/dig-components/menu';
import { Group } from './group';
import { IconButton } from '@dropbox/dig-components/buttons';
import { UIIcon } from '@dropbox/dig-icons';
import { GridViewDenseLine } from '@dropbox/dig-icons/assets';
import { generateGHLogName } from '../utils';
import classnames from 'classnames';
export const Waffle = ({ className, inverse, items, groups = [], open, onToggle, onSelection, hasMaxHeight, menuTriggerAriaLabel, closeOnSelection = false, experimentalUseOnlyWithBottomRow, }) => {
    const footerLinkRenderOptions = {
        getRowProps: () => ({
            className: 'dpc-Waffle-footer-link dpc-Waffle-row-wrapper',
        }),
    };
    const useHrefDirectly = !onSelection;
    return (React.createElement(Menu.Wrapper, { onToggle: onToggle, onSelection: onSelection, closeOnSelection: closeOnSelection, hasMaxHeight: hasMaxHeight }, ({ getTriggerProps, getContentProps }) => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className },
            React.createElement("span", { className: "dpc-Waffle-button-container" },
                React.createElement(IconButton, { ...getTriggerProps(), variant: "transparent", "data-uxa-log": generateGHLogName('waffle'), "data-testid": "dpcWaffleMenuTrigger", "aria-label": menuTriggerAriaLabel, inverse: inverse },
                    React.createElement(UIIcon, { src: GridViewDenseLine })))),
        React.createElement(Menu.Content, { ...getContentProps(), placement: "bottom-end", positioningStrategy: "fixed", ...(typeof open !== 'undefined' ? { open } : {}) },
            React.createElement("div", { className: classnames('dpc-Waffle-menu-content', {
                    'dpc-Waffle-menu-content--has-footer': !!experimentalUseOnlyWithBottomRow,
                }) },
                items.length > 0 && (React.createElement(Group, { group: { items: items }, useHrefDirectly: useHrefDirectly })),
                groups.map((group, index) => (React.createElement(Group, { group: group, key: index, useHrefDirectly: useHrefDirectly }))),
                experimentalUseOnlyWithBottomRow && (React.createElement("div", { className: "dpc-Waffle-group" }, experimentalUseOnlyWithBottomRow(footerLinkRenderOptions)))))))));
};
Waffle.displayName = 'Waffle';
